var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"ready":_vm.prefill},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }